__turbopack_context__.v({
  "box": "WTSKDG_box",
  "choose-different-btn": "WTSKDG_choose-different-btn",
  "cta": "WTSKDG_cta",
  "highlighted": "WTSKDG_highlighted",
  "sticky": "WTSKDG_sticky",
});
